import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PqfLogoVersionComponent} from '@appComponents/shared/pqf-logo-version/pqf-logo-version.component';

@NgModule({
  declarations: [PqfLogoVersionComponent],
  imports: [CommonModule],
  exports: [PqfLogoVersionComponent],
})
export class PqfLogoVersionModule {}
